import { Button, Tooltip } from "flowbite-react";
import { HiOutlinePlus } from "react-icons/hi";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../Reducers/store";
import { UserLevelNames } from "../../Models/UserLevel";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import EventSponsorApi from "../../Api/EventSponsorApi";
import { EventSponsor } from "../../Models/EventSponsor";
import AddEditEventSponsorModal from "../Events/Sponsors/AddEditEventSponsorModal";
import EventSponsorsList from "../Events/Sponsors/EventSponsorsList";

export default function AdminEventSponsorsPage() {
  const { userModel } = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const [sponsors, setSponsors] = useState<EventSponsor[]>([]);

  useEffect(() => {
    if (userModel && userModel.userLevelId !== UserLevelNames.SuperAdmin) {
      toast.error("You do not have permission to access this page.");
      navigate("/");
    }
  }, [userModel, navigate]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState<EventSponsor | null>(
    null
  );

  const fetchSponsors = () => {
    setLoading(true);
    EventSponsorApi.getAll()
      .then((res) => {
        setSponsors(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchSponsors();
  }, []);

  useEffect(() => {
    if (!showModal) fetchSponsors();
  }, [showModal]);

  const handleAdd = () => {
    setSelectedSponsor(null);
    setShowModal(true);
  };

  const handleEdit = (s: EventSponsor) => {
    setSelectedSponsor(s);
    setShowModal(true);
  };

  return (
    <div className="w-full">
      <div className="w-full p-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <h1 className="text-gray-900 font-bold text-4xl">Event Sponsors</h1>
          <Tooltip content="Add Sponsor">
            <Button onClick={handleAdd} className="buttonMain">
              <HiOutlinePlus />
            </Button>
          </Tooltip>
        </div>
      </div>
      <div className="w-full p-4 pt-0">
        {loading && <Loader />}
        <EventSponsorsList
          data={sponsors}
          onEdit={handleEdit}
          onDelete={(id) => {
            if (window.confirm("Delete this sponsor?")) {
              EventSponsorApi.delete(id).then(() => fetchSponsors());
            }
          }}
        />
      </div>
      <AddEditEventSponsorModal
        show={showModal}
        setShow={setShowModal}
        sponsor={selectedSponsor}
        onSaved={fetchSponsors}
      />
    </div>
  );
}
